export default __webpack_public_path__ + "static/media/doughnut-1.73bafffd.jpeg";